<template>
  <div class="side welfare">
    <div class="h-tt">
      <h2>领会员福利</h2>
      <!-- <div class="welfare-drop">
        <DropDown
          ref="drop"
          :list="serverList"
          :stat-params="statParams"
          def-index="0"
          @change="curGameIndex = $event"
        />
      </div> -->
    </div>
    <div class="box">
      <Observer
        v-for="(item, i) in welfares"
        :key="i"
        class="welfare-item"
        @show="reportShow(item)"
      >
        <span class="pic">
          <img :src="item.img_url" />
        </span>
        <p class="t1">{{ item.title }}</p>
        <p class="t2">{{ item.description }}</p>
        <a
          href="javascript:;"
          class="btn1"
          @click="
            $util.jumpUrl(item.jump_url)
            reportClick(item)
            clickStat(i)
          "
          >领取</a
        >
      </Observer>
    </div>
  </div>
</template>

<script>
// import DropDown from '~/components/common/DropDown'
export default {
  components: {
    // DropDown
  },
  data() {
    return {
      welfares: [],
      serverList: [],
      curGameIndex: 0,
      statParams: {
        eid: 'GWSY/LHYFL',
        eid_desc: '官网首页/领会员福利'
      }
    }
  },
  watch: {
    curGameIndex() {
      this.getGifts()
    }
  },
  created() {
    if (process.client) {
      this.$request('giftGames').then((data = []) => {
        this.serverList = data
        if (data.length) {
          this.getGifts()
        }
      })
    }
  },
  methods: {
    getGifts() {
      const game_id = this.serverList[this.curGameIndex].game_id
      this.$request('welfareAct', { body: { game_id } }).then((data) => {
        this.welfares = data
      })
    },
    reportShow(e) {
      this.$xlaPush('home_page_task_content_show', {
        game_id: e.game_id,
        gift_info: e.title,
        status: 'receive'
      })
    },
    reportClick(e) {
      this.$xlaPush('home_page_task_content_click', {
        game_id: e.game_id,
        gift_info: e.title,
        click_id: 'receive'
      })
    },
    clickStat(index) {
      let eid = ''
      let eid_desc = ''
      switch (index) {
        case 0:
          eid = 'QD'
          eid_desc = '签到'
          break
        case 1:
          eid = 'CJ'
          eid_desc = '冲级'
          break
        case 2:
          eid = 'CZ'
          eid_desc = '充值'
          break
      }
      this.$util.clickStat(
        `${this.statParams.eid}/${eid}`,
        `${this.statParams.eid_desc}/${eid_desc}`
      )
    }
  }
}
</script>
